import {
  IonButton,
  IonCol,
  IonItem,
  IonLabel,
  IonRow,
  IonTextarea,
} from "@ionic/react";
import { useEffect, useState } from "react";
import ReactS3Client from "react-aws-s3-typescript";
// import { Carousel } from "react-responsive-carousel";
import { v4 as uuidv4 } from "uuid";
import { makeGETRequest, makePOSTRequest } from "../../request/rawRequest";

import { getCurrentTechnoOrDisconnect } from "../../variables/jobDictionnary";
import {
  ACCESS_KEY,
  REGION,
  S3_BUCKET,
  SECRET_ACCESS_KEY,
} from "../../variables/s3Variables";
import BasicPage from "../BasicPage/BasicPage";
import "../IonColor/color.css";
import "../generalCSS/stylesheet.css";
import "./AddReal.css";

import { Carousel } from "@mantine/carousel";
import { FileInput } from "@mantine/core";

interface ContainerProps {}

const s3Config = {
  bucketName: S3_BUCKET,
  region: REGION,
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
};

const AddReal: React.FC<ContainerProps> = () => {
  const [files, setFiles] = useState<any[]>([]);
  const [images, setImages] = useState<any[]>([]);
  const [load, setLoad] = useState<boolean>(false);

  const [title, setTitle] = useState<string>("");
  useEffect(() => {
    const imagesLoad: any[] = [];
    const fileReaders = [];

    files.forEach((fileUnique: any) => {
      const fileReader = new FileReader();

      fileReaders.push(fileReader);
      fileReader.onload = (e) => {
        const { result } = e.target!;
        if (result) {
          imagesLoad.push(result);
        }
        if (imagesLoad.length === files.length) {
          setImages([...imagesLoad]);
        }
      };
      fileReader.readAsDataURL(fileUnique);
    });
    if (files.length > 4) setFiles((old) => old.slice(0, 4));
  }, [files]);

  const uploadToS3Bucket = async (files: any[]) => {
    setLoad(true);
    let username: string = "";
    await makeGETRequest("/me").then((response) => {
      username = response.email;
    });

    const linkArray: Array<string> = [];
    const uuid = uuidv4();
    const s3 = new ReactS3Client({
      ...s3Config,
      dirName: `${username}/${uuid}`,
    });

    for (const file of files) {
      try {
        const res = await s3.uploadFile(file);
        linkArray.push(res.location);
      } catch (exception) {
        console.error(exception);
      }
    }
    await makePOSTRequest("/realidation", {
      email: username,
      link: linkArray,
      category: getCurrentTechnoOrDisconnect(),
      exercice: title,
    }).then((resp: any) => {
      window.location.reload();
    });
  };

  return (
    <BasicPage
      pathReturn
      title="Partage ta réalisation"
      subtitle="Nos formateurs évalueront et commenteront ta réalisation"
    >
      <IonRow className="ion-justify-content-center">
        <IonItem className="fullWidth">
          <IonLabel color="black" position="floating">
            Titre de la réalisation et remarques
          </IonLabel>
          <IonTextarea
            color="black"
            onKeyUp={(e) =>
              setTitle((e.target as HTMLInputElement).value ?? "")
            }
            placeholder="Décris ce que tu as fait"
          ></IonTextarea>
        </IonItem>
        <div className="empty-item"></div>
        <IonCol>
          <IonRow className="ion-justify-content-center">
            <FileInput
              disabled={files.length >= 4}
              onChange={(file) => {
                if (file !== null && file !== undefined) {
                  setFiles((old) => [...old, file]);
                }
              }}
              accept="image/png,image/jpeg"
              w={"100%"}
              label={
                <>
                  Ajoute jusqu'à<span className="bold">&nbsp;4&nbsp;</span>
                  photos
                </>
              }
              styles={{
                input: {
                  display: "none",
                },
                label: {
                  fontSize: 20,
                  cursor: "pointer",
                  border: "solid 2px var(--ion-color-primary-contrast)",
                  color: "var(--ion-color-primary-contrast)",
                  borderRadius: 20,
                  padding: 5,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.75)",
                },
              }}
            />
          </IonRow>
          {title.length > 0 && files.length > 0 && (
            <IonRow className="ion-justify-content-center">
              <IonCol size="8">
                {load === false && (
                  <IonButton
                    color="secondary"
                    fill="solid"
                    shape="round"
                    expand="full"
                    // className="input-send bold primary-contrast-text"
                    onClick={() => uploadToS3Bucket(files)}
                  >
                    Envoyer
                  </IonButton>
                )}
              </IonCol>
            </IonRow>
          )}
        </IonCol>
        <div className="empty-item"></div>

        {images.length > 0 && (
          <Carousel w={"100%"} h={"auto"} mx="auto" withIndicators>
            {images.map((img, i) => {
              return (
                <Carousel.Slide
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src={img}
                    key={i}
                    className="input-img"
                    alt={"realisations n°" + i}
                  />
                </Carousel.Slide>
              );
            })}
          </Carousel>
        )}
      </IonRow>
      <IonRow>
        <IonItem color="transparent"></IonItem>
      </IonRow>
    </BasicPage>
  );
};

export default AddReal;
